<template>
	<div class="szzy">
		<div class="szzy_banenr">
			<img src="../../assets/home/home_banner.png" >
		</div>
		<div class="datalist">
			<div class="one_class">
				<el-skeleton :loading="loading" animated :count="oneClass.length">
					<template slot="template">
						<div class="classitem"><el-skeleton-item variant="text" style='width: 45px;height: 30px;'/></div>
					</template>
					<template>
						<div class="classitem" :class="{selectClass:getdata.mid2 == item.id}" @click="changeData(item.id)" v-for="(item,index) in oneClass">{{item.type}}</div>
					</template>
				</el-skeleton>
			</div>
			<div class="lists">
				<el-skeleton :loading="loading" animated :count="datawrap.length">
					<template slot="template">
						<div class="listsItem">
							<div class="top_img">
								<el-skeleton-item
									variant="image"
									style="width: 284px;height: 168px;margin: auto;"
								/>
							</div>
							<div class="bottom_words">
								<div class="bottom_title"><el-skeleton-item variant="text" style='height:100%;width:100%'/></div>
								<div class="keys"><el-skeleton-item variant="text" style='height:100%;width:100%'/></div>
							</div>
						</div>
					</template>
					<template>
						<div class="listsItem" v-for="item in datawrap" @click="goDetail(item.bs_id,item.id)">
							<div class="top_img">
								<img :src="item.v_img" >
							</div>
							<div class="bottom_words">
								<div class="bottom_title">{{item.title}}</div>
								<div class="keys">{{item.v_keys}}</div>
							</div>
						</div>
						<el-empty style="margin: auto;" description="暂无数据" v-if='datawrap.length == 0'></el-empty>
					</template>
				</el-skeleton>
			</div>
			<div class="line" v-if="false"></div>
			<div class="paihang" v-if="false">
				<div class="paihangItem">
					<div class="phtitle">最热资源</div>
					<div class="phlist">
						<div class="phlistItem">
							<span>
								<img src="../../assets/pdficon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/ppticon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
					</div>
				</div>
				<div class="paihangItem">
					<div class="phtitle">最新资源</div>
					<div class="phlist">
						<div class="phlistItem">
							<span>
								<img src="../../assets/pdficon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/ppticon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
					</div>
				</div>
				<div class="paihangItem">
					<div class="phtitle">上传榜单</div>
					<div class="phlist">
						<div class="phlistItem">
							<span>
								<img src="../../assets/pdficon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/ppticon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
						<div class="phlistItem">
							<span>
								<img src="../../assets/videoicon.png" >
							</span>
							<span>如何理解“两山论”的科学论断的科学论断的科学论断的科学论断的科学论断的科学论断</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { resource } from '@/axios';
	import $ from 'jquery';
	export default{
		data(){
			return{
				oneClass:[],
				getdata:{
					mid2:1,
					page:1
				},
				loading:true,
				datawrap:[]
			}
		},
		methods:{
			// 分类列表
			classList(){
				var that = this;
				resource.politicsClass().then(res => {
					if(res.code == 200){
						that.oneClass = res.data
					}
				})
			},
			// 资源列表
			datalist(){
				var that = this;
				that.datawrap = [];
				resource.politicsResouce(that.getdata).then(res => {
					if(res.code == 200){
						if(res.data.pagedata.length > 0){
							that.datawrap = res.data.pagedata;
						}
						that.loading = false;
					}
				})
			},
			// 筛选
			changeData(id){
				var that = this;
				that.getdata.mid2 = id;
				that.getdata.page = 1;
				that.datalist();
			},
			// 详情
			goDetail(bs_id,id){
				var that = this;
				this.$emit("highLight",this.$route.query.index,bs_id,id,1)
			}
		},
		mounted(){
			var that = this;
			that.classList();
			that.datalist();
		},
		created() {
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.szzy{
		width: 100%;
		&_banenr{
			width: 100%;
			img{
				z-index: 10;
				width: 100%;
				height: auto;
			}
		}
		.datalist{
			position: relative;
			width: $indexWidth;
			margin: auto;
			.one_class{
				padding: 0 30px;
				box-sizing: border-box;
				position: absolute;
				z-index: 10;
				width: $indexWidth;
				height: 80px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin: -40px auto 0 auto;
				left: 50%;
				transform: translateX(-50%);
				background: $indexColor4;
				box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.12);
				border-radius: 6px;
				>div{
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
				.el-skeleton{
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
				.classitem{
					padding: 10px 20px;
					margin-left: 5px;
					cursor: pointer;
					font-size: 16px;
					font-family: $indexFontSubTitle1;
					font-weight: bold;
					color: $indexColor2;
				}
				.classitem:nth-child(1){
					margin-left: 0 !important;
				}
				.classitem:hover{
					color: #fff;
					background-color: #CB272B;
					border-radius: 20px;
				}
				.selectClass{
					padding: 10px 20px;
					cursor: pointer;
					font-size: 16px;
					font-family: $indexFontTitle;
					font-weight: bold;
					color: #fff;
					background-color: #CB272B;
					border-radius: 20px;
				}
			}
			.lists{
				width: 100%;
				padding-top: 50px;
				display: -webkit-box;
				display: -moz-box; 
				display: -webkit-flex; 
				-webkit-flex-wrap: wrap;  
				-moz-flex-wrap: wrap;  
				-ms-flex-wrap: wrap;  
				-o-flex-wrap: wrap;  
				flex-wrap: wrap;
				.el-skeleton{
					display: -webkit-box;
					display: -moz-box; 
					display: -ms-flexbox; 
					display: -webkit-flex; 
					display: flex; 
					-webkit-flex-wrap: wrap;  
					-moz-flex-wrap: wrap;  
					-ms-flex-wrap: wrap;  
					-o-flex-wrap: wrap;  
					flex-wrap: wrap;
				}
				>div{
					display: -webkit-box;
					display: -moz-box; 
					display: -ms-flexbox; 
					display: -webkit-flex; 
					display: flex; 
					-webkit-flex-wrap: wrap;  
					-moz-flex-wrap: wrap;  
					-ms-flex-wrap: wrap;  
					-o-flex-wrap: wrap;  
					flex-wrap: wrap;
				}
				.listsItem{
					display: inline-block;
					cursor: pointer;
					width: 284px;
					box-sizing: border-box;
					margin: 21px 21px 0 0;
					height: 250px;
					border: 1px solid rgba(0,0,0,.1);
					.top_img{
						width: 100%;
						height: 168px;
						overflow: hidden;
						img{
							background: rgba(0,0,0,.1);
							width: 100%;
							height: 100%;
							object-fit: cover;
							transition: all 0.3s;
						}
					}
					.bottom_title{
						font-weight: bold;
						font-size: 16px;
						margin-top: 10px;
						color: $indexColor1;
						line-height: 22px;
						font-family: $indexFontSubTitle1;
						height: 22px;
						overflow: hidden;
						display: -webkit-box;
						word-break: break-all;
						text-overflow: ellipsis; 
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						padding: 0 20px;
						box-sizing: border-box;
					}
					.keys{
						padding: 0 20px;
						box-sizing: border-box;
						font-size: 13px;
						color: #939393;
						line-height: 18px;
						overflow: hidden;
						display: -webkit-box;
						word-break: break-all;
						text-overflow: ellipsis; 
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						margin-top: 17px;
					}
				}
				.listsItem:hover{
					img{
						transform: scale(1.1);
					}
					.bottom_title,.keys{
						color: #bb0000;
					}
				}
				.listsItem:nth-child(4n){
					margin-right: 0;
				}
			}
			.line{
				width: $indexWidth;
				height: 1px;
				background: #E6E6E6;
				margin: 20px auto 40px auto;
			}
			.paihang{
				width: 100%;
				margin: auto;
				display: flex;
				justify-content: space-between;
				.paihangItem{
					width: 380px;
					height: 491px;
					border: 1px solid #E6E6E6;
					box-sizing: border-box;
					padding: 0 28px;
					.phtitle{
						width: 100%;
						height: 70px;
						text-align: center;
						line-height: 70px;
						color: $indexColor2;
						font-size: 20px;
						font-weight: bold;
						border-bottom: 1px solid #E6E6E6;
					}
					.phlist{
						width: 100%;
						height: 370px;
						overflow-y: scroll;
						overflow-x: hidden;
						margin-top: 20px;
						.phlistItem{
							display: flex;
							align-items: center;
							cursor: pointer;
							>span:nth-child(1){
								position: relative;
								width: 18px;
								height: 23px;
								margin-right: 10px;
								img{
									width: 100%;
									height: 100%;
								}
							}
							>span:nth-child(2){
								width: 280px;
								overflow: hidden;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
							}
							line-height: 40px;
							font-size: 14px;
							color: $indexColor1;
						}
						.phlistItem:hover{
							color: #bb0000;
						}
					}
					.phlist::-webkit-scrollbar{
						width:0;
						height:12px;
					}
				}
			}
		}
	}
</style>
